import { loadable } from 'utils';

export const Results = loadable(() => import('./Results'), {});
